require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-domain-prestige-paul-conrad.json") })
        }
      }, "path---journal-domain-prestige-paul-conrad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-domain-prestige-paul-conrad!./.cache/json/journal-domain-prestige-paul-conrad.json
// module id = 481
// module chunks = 231608221292675